/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRuleContent
 */
export interface InternalApiScreeningClearanceRuleContent {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningClearanceRuleContent
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRuleContent
     */
    content: string;
    /**
     * 
     * @type {InternalApiScreeningClearanceRuleContentStatusEnum}
     * @memberof InternalApiScreeningClearanceRuleContent
     */
    status: InternalApiScreeningClearanceRuleContentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRuleContent
     */
    note?: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScreeningClearanceRuleContent
     */
    lastUpdatedBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRuleContent
     */
    lastUpdatedTime?: Date;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiScreeningClearanceRuleContentStatusEnum {
    DRAFT = 'DRAFT',
    HISTORIC = 'HISTORIC',
    CURRENT = 'CURRENT'
}


/**
 * Check if a given object implements the InternalApiScreeningClearanceRuleContent interface.
 */
export function instanceOfInternalApiScreeningClearanceRuleContent(value: object): value is InternalApiScreeningClearanceRuleContent {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRuleContentFromJSON(json: any): InternalApiScreeningClearanceRuleContent {
    return InternalApiScreeningClearanceRuleContentFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRuleContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRuleContent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'content': json['content'],
        'status': json['status'],
        'note': json['note'] == null ? undefined : json['note'],
        'lastUpdatedBy': json['lastUpdatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['lastUpdatedBy']),
        'lastUpdatedTime': json['lastUpdatedTime'] == null ? undefined : (new Date(json['lastUpdatedTime'])),
    };
}

export function InternalApiScreeningClearanceRuleContentToJSON(json: any): InternalApiScreeningClearanceRuleContent {
    return InternalApiScreeningClearanceRuleContentToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRuleContentToJSONTyped(value?: InternalApiScreeningClearanceRuleContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
        'status': value['status'],
        'note': value['note'],
        'lastUpdatedBy': InternalApiUserBasicDetailsToJSON(value['lastUpdatedBy']),
        'lastUpdatedTime': value['lastUpdatedTime'] == null ? value['lastUpdatedTime'] : value['lastUpdatedTime'].toISOString(),
    };
}

